import axios from 'axios'
import 'es6-promise/auto'

function getBaseURL () {
  let url = ''

  if (process.env.NODE_ENV === 'development') {
    url = 'http://localhost:8000'
  } else {
    url = 'https://go.newsreview.com'
  }
  return url
}

const instance = axios.create({
  baseURL: getBaseURL()
})

export default instance



// WEBPACK FOOTER //
// ./src/axios-conf.js